import React, { useState } from 'react';
import { FaShare, FaTimes, FaQrcode, FaLink } from 'react-icons/fa';
import { QRCodeSVG } from 'qrcode.react';

const DisplayShare = ({ eventId, eventName, qrCodeUrl }) => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('menu'); // 'menu' | 'qr'
  const [copied, setCopied] = useState(false);

  const shareUrl = qrCodeUrl || `${window.location.origin}/${eventId}/upload`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: eventName || 'Invitation',
          text: 'Rejoignez cet événement !',
          url: shareUrl,
        });
        setOpen(false);
        setMode('menu');
      } catch (err) {
        if (err?.name !== 'AbortError') console.error('Erreur de partage:', err);
      }
    } else {
      try {
        await navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
          setOpen(false);
          setMode('menu');
        }, 1200);
      } catch (e) {
        console.error('Erreur de copie:', e);
      }
    }
  };

  return (
    <>
      <div className="share-zone">
        <div className="qr-code-container">
          <QRCodeSVG value={shareUrl} size={180} />
        </div>

        <button
          type="button"
          className="share-trigger"
          onClick={() => { setOpen(true); setMode('menu'); }}
          aria-label="Partager l'invitation"
          title="Partager l'invitation"
        >
          <FaShare size={14} />
        </button>
      </div>

      {open && (
        <div
          className="review-modal-overlay-display"
          role="dialog"
          aria-modal="true"
          onClick={() => { setOpen(false); setMode('menu'); }}
        >
          <div className="review-modal" onClick={(e) => e.stopPropagation()}>
            <div className="review-modal-header">
              <span>
                {mode === 'menu'
                  ? "Si la personne est à côté, montrez-lui le QR code"
                  : "Faites scanner ce QR pour inviter les personnes autour de vous !"}
              </span>
              <button className="close-btn" onClick={() => { setOpen(false); setMode('menu'); }} aria-label="Fermer">
                <FaTimes />
              </button>
            </div>

            {mode === 'menu' ? (
              <>
                <p className="modal-text" style={{ textAlign: 'center' }}>
                  <span style={{ color: '#cbd5e1' }}>
                    Sinon partagez le lien d’invitation :
                  </span>
                </p>

                <div className="modal-actions">
                  <button
                    type="button"
                    className="btn-gold-outline"
                    onClick={() => setMode('qr')}
                  >
                    <FaQrcode size={20} />
                    <span>Montrer le QR code</span>
                  </button>

                  <button
                    type="button"
                    className="btn-gold-outline"
                    onClick={handleShare}
                  >
                    <FaLink size={20} />
                    <span>
                      {copied
                        ? '✓ Copié !'
                        : navigator.share
                        ? "Partager le lien d’invitation"
                        : "Copier le lien d’invitation"}
                    </span>
                  </button>
                </div>
              </>
            ) : (
              <div className="qr-modal-content">
                <div className="qr-modal-card">
                  <QRCodeSVG value={shareUrl} size={250} />
                </div>
                {eventName && (
                  <p className="qr-modal-event">{eventName}</p>
                )}
                <div className="modal-actions">
                  <button
                    type="button"
                    className="btn-gold-outline"
                    onClick={() => setMode('menu')}
                  >
                    ← Retour
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DisplayShare;
